import { render, staticRenderFns } from "./generator.card.description.vue?vue&type=template&id=01abf361&"
import script from "./generator.card.description.vue?vue&type=script&lang=ts&"
export * from "./generator.card.description.vue?vue&type=script&lang=ts&"
import style0 from "./generator.card.description.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports